import { Component, OnInit } from '@angular/core';
import {NavigationEnd, Router} from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  isContactsPage: boolean;

  constructor(private router: Router) {
    this.isContactsPage = false;
    this.router.events
      .subscribe((event) => {
        if (event instanceof NavigationEnd) {
          this.isContactsPage = (event.urlAfterRedirects !== '/contact');
        }
      });
  }

  ngOnInit() {
    this.isContactsPage = false;
  }

}
